import { Asset } from "@iventis/domain-model/model/asset";
import { Model } from "@iventis/domain-model/model/model";

export type ModelAsset = Model & { thumbnail: Asset };
